<template>
<!--  <div class="pt-select-div" v-if="$attrs.mode == 'multiple'">-->
<!--    <a-select  :allowClear="allowClear" :style="selectStyle" :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>-->
<!--      <a-icon slot="suffixIcon" type="caret-down" />-->
<!--      <a-select-option v-for="(item,inde) in users" :key="inde" v-if="!showQuit" :disabled="disabledUsers.indexOf(item.accountid) != -1" :value="item.accountid"><span :class="item.active?'quiteClass':''">{{item.userName}}</span></a-select-option>-->
<!--      <a-select-option v-for="(item,inde) in users" :key="inde" v-if="showQuit && item.active" :disabled="disabledUsers.indexOf(item.accountid) != -1" :value="item.accountid"><span>{{item.userName}}</span></a-select-option>-->
<!--    </a-select>-->
<!--    <a-icon class="multiple-icon" :class="open?'openClass':''" type="caret-down"></a-icon>-->
<!--  </div>-->
  <a-select  :allowClear="allowClear"   :filterOption="filterOption" option-label-prop="label" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
    <a-icon slot="suffixIcon" type="caret-down" />
    <a-select-option class='showPadding' v-for="(item,inde) in users" :label="item.userName" :key="inde" :disabled="disabledUsers.indexOf(item.accountid) != -1" :value="item.accountid">
      <div class='selectShow' >
        <div style='width: 150px;;text-align: left;font-size: 12px;color: #333333;font-weight: 600;' :class="item.active?'quiteClass':''">{{item.userName}}</div>
        <div style='font-size: 12px;color: #999999;font-weight: 600;' :class="item.active?'quiteClass':''">{{item.companyName}}</div>
      </div>
    </a-select-option>
  </a-select>

<!--  <a-select v-else :allowClear="allowClear"  :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>-->
<!--    <a-select-option   v-for="(item,inde) in users" :key="inde" :disabled="disabledUsers.indexOf(item.accountid) != -1" :value="item.accountid">-->
<!--      <span  :class="item.active?'quiteClass':''">{{item.userName}}</span>-->
<!--    </a-select-option>-->
<!--  </a-select>-->

</template>

<script>
/**
 * 包含离职人员
 */
import UserApi from '@/api/sys/user'
export default {
  name: 'ptUserSelectOrPutAll',
  props:{
    placeholder:{
      type:String,
    },
    selectShow:{
      type:Boolean,
      default:true,
    },
    allowClear:{
      type:Boolean,
      default:true,
    },
    value:{
      type: [Object, Array] | String,
    },
    disabledUsers:{
      type:Array,
      default:()=>{return []}
    },
    companyId:{
      type:String,
    },
    showQuit:{
      type:Boolean,
      default:false,
    },
    postAdjustFlag:{
      type:Boolean,
      default:false,
    },
    selectStyle:{
      type:Object,
      default:()=>{
        return {width:'100%'}
      }
    },
  },
  data() {
    return {
      input:this.value,
      users:[],
      open:false,
    }
  },
  watch:{
    value (val) {
      this.input = val
      console.log("this.input",val)
    },
    input(val){
      this.$emit('input',val)
    },
    companyId(){
      this.initData()
    },
  },
  mounted(){
    this.initData()
  },
  methods:{
    dropdownVisibleChange(open){
      this.open = open
    },
    filterOption(input, option){
      return (
        option.componentOptions.children[0].children[0].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    initData() {
      let queryVO ={}
      // if(this.companyId){
      //   if (!this.postAdjustFlag){
      //     queryVO.companyId = this.companyId
      //   }
      // }
      queryVO.companyId = this.companyId
      UserApi.selectAllUsers(queryVO).then(res => {
        if (res.code == 1) {
          this.users = res.data.filter(o=>!o.active)
        }
      })
    },
    changeValue(value){
      this.$emit('input',value)
    },



  }
}
</script>

<style scoped lang="less">
.pt-select-div{
  position: relative;
  width: 100%;
  display: inline;
  /deep/ .ant-select-selection--multiple .ant-select-selection__placeholder{
    margin-left: 0px;
  }




  .multiple-icon{
    position: absolute;
    color: rgba(0, 0, 0, 0.25);
    right: 11px;
    top: 10px;
    font-size: 12px;
  }
  .openClass{
    transform: rotate(180deg);
  }
}

.selectShow{
  display: flex;
}

.quiteClass{
  color: #a1a1a1;
}
</style>

<style>
.showPadding {

}
</style>